import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'convertWithDecimal'
})
export class ConvertWithDecimalPipe implements PipeTransform {
    transform(
        value: any,
        selectedVehicle: any,
        paramKey: any = false,
        roundOfRequired = false,
        title = ''
      ): any {
        const MAXIMUM_AMOUNT = 1000000000; // 1 Billion
    
        if (paramKey === true && value === null) {
          return '-';
        }


        const parseUnknownLocaleNumber = (str: string | number) => {
          // If input is already a number, return it
          if (typeof str === 'number') {
            return str;
          }
          
          // Remove spaces and non-breaking spaces
          str = str.replace(/\s|\u00A0/g, '');
        
          const commaCount = (str.match(/,/g) || []).length;
          const dotCount = (str.match(/\./g) || []).length;
        
          let normalized;
        
          if (commaCount === 1 && dotCount === 0) {
            // Example: "5355,00" → European style
            normalized = str.replace(',', '.');
          } else if (dotCount === 1 && commaCount === 0) {
            // Example: "5355.00" → US style
            normalized = str;
          } else if (commaCount > 1 && dotCount === 1) {
            // Example: "5,355.00" → US style with thousands separator
            normalized = str.replace(/,/g, '');
          } else if (dotCount > 1 && commaCount === 1) {
            // Example: "5.355,00" → European style with thousands separator
            normalized = str.replace(/\./g, '').replace(',', '.');
          } else {
            // Ambiguous or already normalized
            normalized = str.replace(/[^0-9.-]/g, '');
          }
        
          const result = parseFloat(normalized);
          return isNaN(result) ? null : result;
        }
    
        let format = 'en-US';
    
        if (value != null || value != undefined) {
          if (selectedVehicle) {
            if (
              selectedVehicle.separators &&
              selectedVehicle.separators.thousands === '.' &&
              selectedVehicle.separators.decimal === ','
            ) {
              format = 'de-DE';
            }
          }
    
          let convertedAmount;
    
          if (title !== 'IRR') {
            try{
              convertedAmount = parseUnknownLocaleNumber(value)?.toLocaleString(format, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            } catch (error) {
              throw new Error('Invalid number');
            }
          } else {
            try{
              convertedAmount = parseUnknownLocaleNumber(value)?.toLocaleString(format, {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              });
            } catch (error) {
              throw new Error('Invalid number');
            }
          }
    
          if (roundOfRequired && value >= MAXIMUM_AMOUNT) {
            convertedAmount = parseUnknownLocaleNumber(value)?.toLocaleString(format, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            });
          }
    
          if (selectedVehicle?.negativeNumbers === 'parentheses') {
            const isNegative = convertedAmount?.toString().startsWith('-');
            if (isNegative) {
              return `(${convertedAmount?.toString().substring(1)})`;
            }
          }
          return convertedAmount
        }
    
        return 0.0;
      }
}